module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "advs"
  }, [(_vm.url) ? _c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.banner.atturl,
      "alt": "log"
    }
  })]) : _c('img', {
    attrs: {
      "src": _vm.banner.atturl,
      "alt": "log"
    },
    on: {
      "click": function($event) {
        return _vm.showTips('敬请期待！')
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48ac321f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/sale-zone/block.vue
// module id = 1596
// module chunks = 1